import React from 'react';
import { useTranslation } from 'react-i18next';
import { PackageCard } from '@root/components/Package';
import usePackageRenewal from '@root/hooks/usePackageRenewal';
import BillAddress from '../Bill/BillAddress';
import PageLoading from '@root/components/PageLoading';
import PageLoadError from '@root/components/PageLoadError';
import PayMethod from '../PayMethod';

import './style.less';
import Button from '@root/components/Button';
import SafeAreaInset from '@root/components/SafeAreaInset';

const PackageRenewal = () => {
  const { t } = useTranslation();
  const {
    loadingState,
    packageDetail,
    selectPriceId,
    isBillAddress,
    paying,
    onSelected,
    payMethodState,
    onCreateOrder,
    onTryAgain,
  } = usePackageRenewal();

  if (loadingState < 1) {
    return <PageLoading />;
  }

  if (loadingState === 2) {
    return <PageLoadError onTryAgain={onTryAgain} />;
  }

  if (!isBillAddress) {
    return <BillAddress />;
  }

  return (
    <>
      <div className="flex-section-auto navbar-spacing">
        <PayMethod {...payMethodState}></PayMethod>
        <PackageCard
          key={packageDetail.goodsId}
          title={packageDetail.goodsName}
          priceList={packageDetail.goodsPriceList}
          checkedPriceId={selectPriceId}
          description={packageDetail.description}
          onSelected={onSelected}
          maxDevNum={packageDetail.maxDevNum}
          className="mt20"
        />
      </div>
      <div className="flex-section-footer">
        <Button
          disabled={!selectPriceId}
          loading={paying}
          onClick={onCreateOrder}
        >
          {t('purchase_now')}
        </Button>
        <SafeAreaInset />
      </div>
    </>
  );
};

export default PackageRenewal;
